import React, { useEffect, useState } from 'react';
import logo from '../../assets/logo.png';
import './MainVisual.css'; // スタイルシートをインポート

const desktopMainVisualImage = `${process.env.PUBLIC_URL}/media/mv.png`;
const mobileMainVisualImage = `${process.env.PUBLIC_URL}/media/mv-sp.png`;
const desktopMediaQuery = '(min-width: 768px)';

function getMainVisualBackgroundImage() {
  if (typeof window !== 'undefined' && window.matchMedia(desktopMediaQuery).matches) {
    return desktopMainVisualImage;
  }

  return mobileMainVisualImage;
}

const stepItems = [
  {
    id: 'step01',
    label: 'step01',
    icon: `${process.env.PUBLIC_URL}/media/icon-step01.svg`,
    alt: '写真をえらぶ',
  },
  {
    id: 'step02',
    label: 'step02',
    icon: `${process.env.PUBLIC_URL}/media/icon-step02.svg`,
    alt: '手書き文字をアップロードする',
  },
  {
    id: 'step03',
    label: 'step03',
    icon: `${process.env.PUBLIC_URL}/media/icon-step03.svg`,
    alt: 'カレンダーを完成させる',
  },
];

function MainVisual() {
  const [backgroundImage, setBackgroundImage] = useState(getMainVisualBackgroundImage);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const mediaQueryList = window.matchMedia(desktopMediaQuery);
    const updateBackgroundImage = () => {
      setBackgroundImage(mediaQueryList.matches ? desktopMainVisualImage : mobileMainVisualImage);
    };

    updateBackgroundImage();

    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener('change', updateBackgroundImage);

      return () => {
        mediaQueryList.removeEventListener('change', updateBackgroundImage);
      };
    }

    mediaQueryList.addListener(updateBackgroundImage);

    return () => {
      mediaQueryList.removeListener(updateBackgroundImage);
    };
  }, []);

  return (
    <div className="MainVisual" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="mv-copy-block">
        <p className="mv-copy">
          手書きの数字が、
          <br />
          そのままカレンダーに。
        </p>
        <img src={logo} alt="ころみ" className="mv-logo" />

        <div className="mv-steps" aria-label="作成ステップ">
          {stepItems.map((step) => (
            <div className="mv-step-card" key={step.id}>
              <p className="mv-step-label">{step.label}</p>
              <img src={step.icon} alt={step.alt} className="mv-step-icon-image" />
            </div>
          ))}
        </div>
      </div>
      <p className="mv-description">
        お気に入りの写真、手書き文字の写真を
        <br />
        アップロードするだけ！
      </p>
    </div>
  );
}

export default MainVisual;
